<mat-horizontal-stepper #stepper [linear]="true">
    <mat-step [stepControl]="fileUploadFormGroup">
        <ng-template matStepLabel>Choose File</ng-template>
        <div class="file-form">
            <ngx-dropzone (change)="onFileSelected($event)">
                <ngx-dropzone-label>Drop file here to import or Click to select</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let file of files" [removable]="true" (removed)="onRemove(file.name)">
                    <ngx-dropzone-label>{{ file.name }} ({{ file.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
            </ngx-dropzone>
        </div>
        <div class="stepper-buttons">
            <button mat-stroked-button (click)="cancel()">Cancel</button>
            <button mat-raised-button matStepperNext [disabled]="fileUploadFormGroup.invalid">Next</button>
        </div>
    </mat-step>
    <mat-step>
        <ng-template matStepLabel>Verify Import</ng-template>
        <app-importer #importer [mode]="mode" [source]="source" (cardsImported)="importCards($event)"></app-importer>
        <div class="stepper-buttons">
            <button mat-stroked-button matStepperPrevious>Back</button>
            <button mat-raised-button (click)="triggerImport()">Import</button>
        </div>
    </mat-step>
</mat-horizontal-stepper>
